var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('autocomplete',{attrs:{"label":'label',"clear_on_select":true,"placeholder":_vm.$t('settings_tasks.edit_filter_tree_placeholder'),"options":_vm.options},on:{"select":_vm.add_filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }